<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Purchase</p>
      </header>

      <section class="modal-card-body">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <item-title
            :title="purchase.attributes.name"
            :itemType="'purchase'"
            :displaySuccess="false"
            @updateTitle="localPurchase.name = $event"
          />

          <b-field label="Find or add a new Shop">
            <b-autocomplete
              v-model="storeName"
              ref="autocomplete"
              icon="magnify"
              :data="storeNames"
              :loading="searchLoading"
              placeholder="e.g. My Cosplay Shop"
              @select="(option) => (storeName = option)"
            >
            </b-autocomplete>
          </b-field>

          <item-description
            :description="purchase.attributes.description"
            @updateDescription="localPurchase.description = $event"
          />

          <b-field label="Category">
            <b-select
              placeholder="Select a category"
              v-model="localPurchase.craft_purchase_category_id"
            >
              <option
                v-for="category in craftPurchaseCategories"
                :value="category.id"
                :key="category.id"
              >
                {{ category.attributes.name }}
              </option>
            </b-select>
          </b-field>

          <item-tags
            :tags="purchase.attributes.tag_list"
            :placeholder="'WCS, Comic Con, Photoshop...'"
            @updateTags="localPurchase.tag_list = $event"
          />
        </ValidationObserver>
      </section>

      <footer class="modal-card-foot">
        <span class="card-footer-item">
          <b-button @click="$parent.close()"> Close </b-button>
        </span>

        <span class="card-footer-item">
          <b-button @click="update" type="is-success"> Update </b-button>
        </span>
      </footer>
    </div>
  </section>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin.js'
import { ValidationObserver } from 'vee-validate'
import _ from 'lodash'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'
import ItemDescription from '@/components/Attributes/ItemDescription'
import ItemTags from '@/components/Attributes/ItemTags'

const DEBOUNCE_VALUE = 500

export default {
  props: ['purchase'],
  mixins: [notificationMixin],
  data () {
    return {
      localPurchase: {
        name: null,
        description: null,
        craft_purchase_category_id: null,
        store_id: null,
        tag_list: []
      },

      storeNames: [],
      searchLoading: false,
      storeName: null,

      craftPurchaseCategories: []
    }
  },
  components: {
    ValidationObserver,
    ItemTitle,
    ItemDescription,
    ItemTags
  },
  created () {
    this.$store
      .dispatch('craftPurchaseCategories/index')
      .then((resp) => {
        this.craftPurchaseCategories = resp.data.data
      })
      .catch((error) => {
        console.log(error.response)
      })
    this.debouncedGetSearchResults = _.debounce(this.getSearchResults, DEBOUNCE_VALUE)
    this.localPurchase.name = this.purchase.attributes.name
    this.localPurchase.description = this.purchase.attributes.description
    this.localPurchase.craft_purchase_category_id = this.purchase.attributes.craft_purchase_category.data.id
    this.storeName = this.purchase.attributes.store.data.attributes.name
    this.localPurchase.store_id = this.purchase.attributes.store.data.id
    this.localPurchase.tag_list = this.purchase.attributes.tag_list
  },
  methods: {
    update () {
      if (this.storeName) {
        this.$store
          .dispatch('stores/create', { name: this.storeName })
          .then((response) => {
            this.localPurchase.store_id = response.data.data.id
            this.updatePurchase()
          })
          .catch((error) => {
            console.log(error.response)
            this.alertError()
          })
      } else {
        this.updatePurchase()
      }
    },
    updatePurchase () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch('purchases/update', {
              purchase: this.purchase.id,
              payload: this.localPurchase
            })
            .then((resp) => {
              this.actionSuccess('Purchase updated !')
              this.$emit('purchaseUpdated', resp.data.data)
              this.$parent.close()
            })
            .catch((error) => {
              console.log(error.response)
              this.alertError()
            })
        }
      })
    },
    getSearchResults () {
      if (this.storeName !== '') {
        this.$store
          .dispatch('search/stores/create', { name: this.storeName })
          .then(({ data }) => {
            this.storeNames = []
            data.data.forEach((item) => this.storeNames.push(item.attributes.name))
          })
      } else {
        this.storeNames = []
      }
      this.searchLoading = false
    }
  },
  watch: {
    // Watch the searchInput to display a loader or not
    storeName () {
      if (this.storeName === '') {
        this.storeNames = []
        this.stores = []
        this.searchLoading = false
      } else {
        this.debouncedGetSearchResults()
        this.searchLoading = true
      }
    }
  }
}
</script>
